import events from '../events'
import {getCurrentLocaleCode} from '../localization'
import {getAppPath, getCurrentBaseAppPath} from './apps'
import routerEvents, {CHANGE_LOCALE_CODE_EVENT} from './events'
import {basePath, concatPath, getLocaleCodes} from './helpers'
import history, {queryString, routerHash} from './history'
import {trim} from 'core/utility/string'

let currentFullRoute: string,
  previousRoute: string = '/',
  currentFullRouteWithoutLocalCode: string

/**
 * Go to to the given full path
 *
 * @param {string} path
 * @returns {void}
 */
const goTo = (path: string): void => {
  history.push(path)
}

export const navigateTo = (
  path: string,
  localeCode: string | null = null,
  app: string = getCurrentBaseAppPath()
) => {
  path = concatPath(getAppPath(app), path)

  // if current initial locale code
  if (localeCode === null && hasInitialLocaleCode()) {
    localeCode = getCurrentLocaleCode()
  }

  if (localeCode) {
    path = concatPath(localeCode, path)
  }

  goTo(path)
}

/**
 * Get current full path
 *
 * @returns {string}
 */
export function fullRoute() {
  return history.location.pathname
}

function updateFullRoute(route: string) {
  previousRoute = currentFullRoute

  currentFullRoute = route

  const appLocaleCodes = getLocaleCodes().join('|')

  let regex = new RegExp(`^/(${appLocaleCodes})`)

  routerEvents.trigger('change')

  currentFullRouteWithoutLocalCode = currentFullRoute.replace(regex, (_match, localCode) => {
    routerEvents.trigger(CHANGE_LOCALE_CODE_EVENT, localCode)

    return ''
  })
}

/**
 * Navigate to current location and switch language
 *
 * @param  {string} localeCode
 */
export function switchLang(localeCode: string) {
  let route = currentRoute()

  routerEvents.trigger(CHANGE_LOCALE_CODE_EVENT, localeCode)

  navigateTo('/' + route, localeCode)
}

export function initNavigator() {
  history.listen((history) => {
    console.log(history, 'history')
    updateFullRoute(history.location.pathname)
  })

  updateFullRoute(history.location.pathname || '/')
}

/**
 * Get the route without the locale code
 *
 * @returns  {string}
 */
export function currentRoute(): string {
  let route = trim(fullRoute(), '/' + getCurrentLocaleCode()) || '/'

  if (!route.startsWith('/')) {
    route = '/' + route
  }

  route = trim(route, getCurrentBaseAppPath())

  return concatPath(route)
}

/**
 * Check if current route has a locale code
 *
 * @returns  {boolean}
 */
export function hasInitialLocaleCode(): boolean {
  return currentFullRoute !== currentFullRouteWithoutLocalCode
}

 /**
 * Force reload current route content
 *
 * @returns {void}
 */
 export function refresh() {
  var route = fullRoute().replace(basePath(), "");
  var queryParams = queryString().toString().replace("?", "");
  var hashString = routerHash();
  // enable force refresh temporarily
  goTo(concatPath(route) +
    (queryParams ? "?" + queryParams : "") +
    (hashString ? "#" + hashString : ""));

}
